// this is an autogenerated file from DesignSystem/AppointmentActions/ScheduleViaSMSOrEmail/Content/ScheduleViaDialog/Content/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_AppointmentActions_ScheduleViaSMSOrEmail_Content_ScheduleViaDialog_Content_Content($patient_id: uuid!) {
  vaxiom_contact_methods(
    where: {
      association: {
        communication_preferences: {
          patient: { _id: { _eq: $patient_id } }
          type: { _eq: "APPOINTMENT_MESSAGES" }
        }
      }
      dtype: { _in: ["email", "phone"] }
    }
  ) {
    id
    dtype
    phone {
      id
      number
    }
    email {
      id
      address
    }
  }
}

`